import { ProductHitComponent } from "./components/hitComponent/productResultListHit.component";
import { Base } from "./productResultList.base";

export const ProductResultList = Object.assign(Base, {
    HitComponent: ProductHitComponent
});
